import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Sidebar from "../shared/Sidebar";

function OperationalData() {
 
 const baseUrl = process.env.baseUrl;
   const navigate = useNavigate();

  const [formData, setFormData] = useState({
    annualProduction: '',
    shutdownDays: '',
    directHireEmployees: '',
    indirectHireEmployees: '',
    gridElectricity: '',
    independentPower: '',
    solarPower: '',
    dieselConsumed: '',
    heavyOilConsumed: '',
    fuelGasConsumed: '',
    freshWater: '',
    recycledWater: '',
    energyInvestment: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const validate = () => {
    let newErrors = {};
    for (let key in formData) {
      if (!formData[key]) newErrors[key] = "This field is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await axios.post("/api/operational-data", formData); // Update endpoint as needed
      navigate("/electrical");
    } catch (error) {
      console.error("Error submitting operational data:", error);
      alert("Submission failed. Please try again.");
    }
  };

  return (
    <div className="container col-lg-9 mt-5">
      <div className="row">
        <div className="col-md-4">
          <Sidebar />
        </div>

        <div className="col-md-8">
          <div className="form-section">
            <h5 className="mb-4">Operational Data</h5>
            <form onSubmit={handleSubmit}>
              <div className="row mb-3">
                {[
                  { name: 'annualProduction', label: 'Annual Production' },
                  { name: 'shutdownDays', label: 'Shutdown Days per Year' },
                  { name: 'directHireEmployees', label: 'Direct Hire Employees' },
                  { name: 'indirectHireEmployees', label: 'Indirect Hire Employees' },
                  { name: 'gridElectricity', label: 'Grid Electricity Consumption' },
                  { name: 'independentPower', label: 'Independent Power Consumed' },
                  { name: 'solarPower', label: 'Solar Power Generated' },
                  { name: 'dieselConsumed', label: 'Diesel Consumed' },
                  { name: 'heavyOilConsumed', label: 'Heavy Oil Consumed' },
                  { name: 'fuelGasConsumed', label: 'Fuel Gas Consumed' },
                  { name: 'freshWater', label: 'Fresh Water Consumed' },
                  { name: 'recycledWater', label: 'Recycled Water Used' },
                  { name: 'energyInvestment', label: 'Energy Efficiency Investment' }
                ].map((field) => (
                  <div key={field.name} className="col-md-6 mb-3">
                    <input
                      type="number"
                      className={`form-control ${errors[field.name] ? 'is-invalid' : ''}`}
                      placeholder={field.label}
                      name={field.name}
                      value={formData[field.name]}
                      onChange={handleChange}
                    />
                    {errors[field.name] && (
                      <div className="invalid-feedback">{errors[field.name]}</div>
                    )}
                  </div>
                ))}
              </div>

              <button type="submit" className="btn btn-custom w-100">Continue →</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OperationalData;
